import { render, staticRenderFns } from "./sysuser_bidding_hall_bind.vue?vue&type=template&id=3a4556e1&scoped=true"
import script from "./sysuser_bidding_hall_bind.vue?vue&type=script&lang=js"
export * from "./sysuser_bidding_hall_bind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4556e1",
  null
  
)

export default component.exports